import "./common"
import "./catalog"
import "./combo"
import "./basket"
import "./cutlery"
import "./order"
import "./personal"
import "./popups"
import "./actions"
import "./vacancies"
import "frontend-layout"
import "./auth/auth-pass"
import "./actions/sections"
import "./cart-popup"
import "./promocode"
import "./branches-group"
import "./stoplist"
import "./delivery"
import "./countdown"
import "./search"
import "./deposit"
import "./cart"
import "./transfer"
import AuthPass from "./auth/auth-pass"
import "./schedule-cart"
import "./metrics"
import "./manager"
import DeliveryOrder from './order/order';

(function ($) {
  "use strict";

  window.$ = window.jQuery = $;
  $(function () {


    if ($('#cartTransferCatalogModal').length){
      $('#cartTransferCatalogModal').foundation('open');
    }

    if (window.deliveryOrder){
      let deliveryOrder = new DeliveryOrder(window.deliveryOrder);
    }

    let stopListItems = $('#stoplist-block-items');
    if (stopListItems.length) {
      stopListItems.foundation('open');
    }

    /**
     * Закрываем все открытые тултипы на мобилке при сколе
     */
    $(document).on('touchmove', function (e) {
      //блок, который отображается только на мобилках

      let $tooltips = $('[data-is-active="true"]');
      if ($tooltips.length && $tooltips.hasClass('tooltip')) {
        $tooltips.fadeOut(300);
        $tooltips.data('is-active', false);
      }
    });


    /** баннеры для разделов */
    $(document).find('[data-entity="section-promo"]').slick({
      autoplay: true,
      speed: 1500,
      adaptiveHeight: false,
      arrows: true,
      dots: true,
      prevArrow: $(document).find('.sectionbanner__prev'),
      nextArrow: $(document).find('.sectionbanner__next'),
    });

    let $monthWarapper = $(document).find('[data-entity="month-calendar"]');
    if ($monthWarapper.length && $monthWarapper.data('last-open') === 'open') {
      $monthWarapper.addClass("js-open");
    }
    window.authPass = new AuthPass();
  })



  if ($('#cartTransferCatalogModal').length){
    try{
      $('#cartTransferCatalogModal').foundation('open');
    }catch (e) {
      console.log(e);
    }

  }


  /*$(document).on('click', '.camp__link_category', function (e) {
    if ($(document).find('.x-camp-swiper').length === 0) {
      try {
        let slider = $('.camp');
        let slickSlide = $(this).parents('.slick-slide');
        let index = slickSlide.data('slick-index');
        let siblings = slickSlide.siblings();
        let size = siblings.length;
        let step = Math.ceil(slider.slick('slickGetOption', 'slidesToShow') / 3);
        if (index > 0 && index < size) {
          setTimeout(function () {
            slider.slick('slickGoTo', (index - step), false);
          }, 250)
        } else {
          slider.slick('slickGoTo', index, false);
        }
      } catch (e) {
        console.log(e);
      }
    }
  });*/

})(jQuery);
